import { QualificationFields } from '../types';

// Reuse the dialog container the rest of the profile modals mount into.
export const MAIN_CONTAINER_ID = 'main-container-id';

export const MAX_PHOTOS = 4;
export const CSCS_TASK_NAME = 'check_qualifications';
export const CUSTOM_SOURCE = 'custom';
export const INDUSTRY_CRT_TYPE = 'industry';

export const emptyQualificationFields: QualificationFields = {
  full_name: '',
  reference_number: '',
  qualification_name: '',
  issuing_body: '',
  expiry_date: '',
};

// Prompts are shared verbatim with the mobile app so the extraction behaves identically.
export const CSCS_PROMPT =
  'You are reading a UK CSCS (Construction Skills Certification Scheme) card. ' +
  'The first image is the front, the second is the back. Extract the details and respond with ONLY a ' +
  'minified JSON object, no markdown, with exactly these keys: ' +
  '"full_name", "reference_number", "qualification_name", "issuing_body", "expiry_date". ' +
  '"qualification_name" is the card type/scheme (e.g. "CSCS Skilled Worker - Blue Card"). ' +
  '"issuing_body" is the scheme/issuer (e.g. "CITB"). ' +
  '"expiry_date" must be an ISO date (YYYY-MM-DD); if only month/year is shown use the last day of that month. ' +
  'Use an empty string for any value you cannot read confidently.';

export const QUALIFICATION_PROMPT =
  "You are reading photo(s) of a worker's qualification or certificate " +
  '(e.g. NVQ, SMSTS, first-aid certificate, degree, training/competency card). ' +
  'Extract the details and respond with ONLY a minified JSON object, no markdown, with exactly these keys: ' +
  '"full_name", "reference_number", "qualification_name", "issuing_body", "expiry_date". ' +
  '"qualification_name" is the name/title of the qualification or certificate. ' +
  '"issuing_body" is the awarding organisation or institution. ' +
  '"reference_number" is any certificate, registration or candidate number. ' +
  '"expiry_date" must be an ISO date (YYYY-MM-DD); if only month/year is shown use the last day of that month, ' +
  'and use an empty string if it does not expire or is not shown. ' +
  'Use an empty string for any value you cannot read confidently.';

// UI copy (en) — mirrors §7 of the mobile handoff.
export const COPY = {
  choose: {
    title: 'What would you like to add?',
    subtitle: "Snap a photo and we'll read the details, or enter them yourself.",
    cscs: 'Add CSCS card',
    qualification: 'Add another qualification',
  },
  cscsIntro: {
    title: "Let's add your CSCS card",
    subtitle:
      "Take a photo of the front and back. We'll pull out your name, card type and expiry automatically.",
    note: "We use AI to read it. You'll see everything before it saves — edit anything that doesn't look right.",
    primary: 'Scan card',
  },
  qualificationIntro: {
    title: 'Add a qualification',
    subtitle:
      "Take a photo of your certificate or card — or upload one. We'll read the details automatically.",
    primary: 'Add a photo',
  },
  manualLink: 'Enter details manually instead',
  goBack: 'Go back',
  capture: {
    cscsStepFront: 'Step 1 of 2',
    cscsStepBack: 'Step 2 of 2',
    frontTitle: 'Front of card',
    backTitle: 'Back of card',
    frontHint: 'Scan or photograph the front (photo side) of your CSCS card.',
    backHint: 'Now do the same for the back of the card.',
    qualificationHint: 'Take or upload a photo. Add more if you need to.',
    uploadAnother: 'Upload another',
    readContinue: 'Read & continue',
    dropExtraText: 'photo',
  },
  scanning: {
    cscsTitle: 'Vyce AI · Reading your card',
    qualificationTitle: 'Vyce AI · Reading your qualification',
    subtitle: 'Pulling out your name, card type, reference number and expiry…',
  },
  review: {
    title: 'Check your details',
    cscsSubtitle: 'We auto-filled these from your card. Tap any field to edit.',
    qualificationSubtitle: 'We read what we could — fill in anything that’s missing.',
    fields: {
      qualification_name: 'Qualification Name',
      issuing_body: 'Issuing body',
      full_name: 'Full name',
      reference_number: 'Reference Number',
      expiry_date: 'Expiry date',
    },
    save: 'Save to my profile',
  },
  success: {
    cscsTitle: 'CSCS card added',
    qualificationTitle: 'Qualification added',
    cscsSubtitle: "Your card is on your Vyce profile. Employers can see you're CSCS-verified.",
    qualificationSubtitle: 'Your qualification has been added to your Vyce profile.',
    prompt: 'Got any other qualifications?',
    promptSubtitle: 'NVQs, SMSTS, first-aid, degrees… anything that proves what you can do.',
    addAnother: 'Add another qualification',
    done: "I'm done for now",
  },
};
